export interface Settings {
  sound: boolean;
  reducedMotion: boolean;
  touchControls: 'auto' | 'on' | 'off';
}

export interface DailyRecord {
  hops: number;
  timeMs: number;
  path: string[];
}

export interface SaveData {
  settings: Settings;
  daily: Record<string, DailyRecord>;
  stats: { races: number; wins: number; hops: number; sources: number };
  seenHelp: boolean;
}

const KEY = 'rabbit-hole:v1';

const defaults = (): SaveData => ({
  settings: {
    sound: true,
    reducedMotion: typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion: reduce)').matches,
    touchControls: 'auto',
  },
  daily: {},
  stats: { races: 0, wins: 0, hops: 0, sources: 0 },
  seenHelp: false,
});

export function load(): SaveData {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return defaults();
    const d = JSON.parse(raw);
    const base = defaults();
    return {
      ...base,
      ...d,
      settings: { ...base.settings, ...(d.settings ?? {}) },
      stats: { ...base.stats, ...(d.stats ?? {}) },
      daily: d.daily ?? {},
    };
  } catch {
    return defaults();
  }
}

export function save(d: SaveData): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(d));
  } catch {
    /* storage unavailable (private mode); progress just won't persist */
  }
}
